import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=271a4d7e&scoped=true&"
import script from "./modal.vue?vue&type=script&lang=ts&"
export * from "./modal.vue?vue&type=script&lang=ts&"
import style0 from "./modal.vue?vue&type=style&index=0&id=271a4d7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271a4d7e",
  null
  
)

export default component.exports